// extracted by mini-css-extract-plugin
module.exports = {"title":"_3NF4aAiC-l","button":"_1CblEO0Gev"};
    if(module.hot) {
      // 1597843252386
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  